// extracted by mini-css-extract-plugin
module.exports = {"variables":"\"../../variables.css\"","min-desktop-width":"750px","formPage":"formPage_formPage__1_t0T"};